module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Share your Link","description":"Everyone with this link, can see and comment your journal.","label":"Share this link","btnCopy":"Copy and Close"},"es":{"title":"Comparte tu Link","description":"Cualquier persona con el enlace, podrá ver y comentar tu bitácora.","label":"Comparte este enlace","btnCopy":"Copiar y Cerrar"}}')
  delete Component.options._Ctor
}
